import request from '@/utils/request'

export function postBefore (data) {
    return request({
        url: 'chat/pre_inquiry',
        method: 'post',
        data: data
    })
}
